import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import TitleModalContent from './TitleModalContent';
export const TitleModal = {
    show: (onSelect, titles, onDidHideCallback) => {
        Modal.show(<TitleModalContent closeModal={Modal.hide} onPress={onSelect} titles={titles}/>, {
            containerStyle: styles.modal,
            title: 'Title',
            onDidHideCallback,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
